import clsx from "clsx";
import "./Divider.css";

export interface DividerProps {
  className?: string;
}

const Divider = ({ className, ...otherProps }: DividerProps) => (
  <hr className={clsx("calmlens-divider", className)} {...otherProps} />
);

export default Divider;
